import React, { useContext, useState } from 'react';
import '../../../stylesheets/stylesComponents/copy-on-hover.scss';
import { NotificationsContext } from '../../../contexts/NotificationsContext';
import Icon from '../../../muiComponents/Icon';
import { FeedbackMessages } from '../../../utils/commonVariables/messages';

const CopyOnHover = ({ textToCopy, children, className = '' }) => {
    const { setErrorMessage, setSuccessMessage } =
        useContext(NotificationsContext);
    const [hovered, setHovered] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            setSuccessMessage(FeedbackMessages.COPIED);
        } catch (error) {
            console.error(error);
            setErrorMessage(FeedbackMessages.COMMON_ERROR);
        }
    };

    return (
        <div
            className={`copy-on-hover__container ${className}`}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <div className='copy-on-hover__content'>{children}</div>
            <Icon
                iconName='ContentCopy'
                className='copy-on-hover__icon'
                onClick={handleCopy}
                style={{ visibility: hovered ? 'visible' : 'hidden' }}
            />
        </div>
    );
};

export default CopyOnHover;
